function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#222",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-.001 62V0h46v62h-6V6h-34v56zM113.998 0v6h-40v22h24v6h-24v22h40v6h-46V0zM175.998 19V6h-40V0h46v19c0 23.732-19.268 43-43 43h-3v-6h3c20.42 0 37-16.579 37-37zM218.997 0c17.11 0 31 13.89 31 31 0 17.109-13.89 31-31 31h-15v-6h15c13.798 0 25-11.202 25-25s-11.202-25-25-25h-15V0h15z"
}));

var SvgNejdLogo = function SvgNejdLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    mlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 250,
    height: 62,
    viewBox: "0 0 250 62",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNejdLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/NEJD-logo.a46015c4.svg";
export { ForwardRef as ReactComponent };